import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import DetailsList from '../DetailsList';

const columns = [
  {
    key: 'name',
    name: 'Partner',
    fieldName: 'name',
    minWidth: 650,
    maxWidth: 650,
    columnActionsMode: 0,
  },
  {
    key: 'contractCount',
    name: 'Contracts',
    fieldName: 'contractCount',
    maxWidth: 50,
    columnActionsMode: 0,
  },
  {
    key: 'partnerRole',
    name: 'Partner Role',
    fieldName: 'partnerRole',
    columnActionsMode: 0,
  },
];

const PartnersList = ({ items, className: classNameProp, ...other }) => {
  const className = clsx(classNameProp);

  return (
    <DetailsList
      items={items.map(partner => ({
        ...partner,
        key: partner.name,
        link: `/partners/${partner.partnerAddress}`,
      }))}
      columns={columns}
      className={className}
      {...other}
    />
  );
};

PartnersList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      partnerAddress: PropTypes.string.isRequired,
      contractCount: PropTypes.number.isRequired,
    }),
  ),

  className: PropTypes.string,
};

PartnersList.defaultProps = {
  items: [],
  className: '',
};

export default PartnersList;
